import {useContext} from 'react';
import AddToHomePromptContext, {AddToHomePromptContextValue} from './AddToHomePromptContext';

export default function useAddToHomePromptContext(): AddToHomePromptContextValue {
  return useContext(AddToHomePromptContext);
}
